import { render, staticRenderFns } from "./AddonCasLogin.vue?vue&type=template&id=489a0e03&"
import script from "./AddonCasLogin.vue?vue&type=script&lang=js&"
export * from "./AddonCasLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports